import ServiceTemplate from '@/components/ServiceTemplate';

export default function CFOServices() {
  const data = {
    title: 'CFO Services',
    subtitle: 'Strategic financial leadership and guidance for growing businesses.',
    overviewTitle: 'Why Businesses Need CFO Services',
    overviewImage: 'https://images.unsplash.com/photo-1523875194681-bedd468c58bf',
    description: [
      'CFO services provide strategic financial leadership without the cost of a full-time executive. Our experienced CFOs help businesses make informed decisions, optimize financial performance, and plan for sustainable growth.',
      'From financial planning and analysis to fundraising support and systems implementation, we provide the expertise growing businesses need to achieve their financial goals.',
      'Our CFO services are scalable, providing the right level of support as your business grows from startup to established enterprise.'
    ],
    benefits: [
      { title: 'Strategic Planning', description: 'Long-term financial strategy and planning.' },
      { title: 'Financial Analysis', description: 'In-depth analysis of business performance.' },
      { title: 'Cash Flow Management', description: 'Optimize cash flow and working capital.' },
      { title: 'Fundraising Support', description: 'Prepare for and support capital raising efforts.' },
      { title: 'Systems Implementation', description: 'Implement financial systems and controls.' },
      { title: 'Cost Optimization', description: 'Identify opportunities for cost reduction.' }
    ],
    process: [
      { title: 'Initial Setup & Assessment', description: 'Comprehensive evaluation of current situation and establishment of service framework.' },
      { title: 'Implementation & Management', description: 'Execute ongoing services with regular monitoring, reporting, and optimization.' },
      { title: 'Review & Strategic Guidance', description: 'Periodic reviews with strategic recommendations for continuous improvement.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Initial assessment',
        price: '$299',
        period: 'Per session',
        features: [
          '90-minute consultation',
          'Situation analysis',
          'Strategy recommendations',
          'Action plan',
          'Written summary',
          'Follow-up email support'
        ]
      },
      {
        name: 'Retainer',
        description: 'Ongoing advisory',
        price: '$1,499',
        period: 'Per month',
        featured: true,
        features: [
          'Monthly strategy sessions',
          'Unlimited email support',
          'Priority phone access',
          'Document review',
          'Compliance monitoring',
          'Quarterly reporting',
          'Dedicated attorney'
        ]
      },
      {
        name: 'Project-Based',
        description: 'Custom engagement',
        price: 'Custom',
        period: 'Based on scope',
        features: [
          'Scope-based pricing',
          'Dedicated team',
          'Project management',
          'Milestone deliverables',
          'All work product included',
          'Comprehensive reporting',
          'Executive support'
        ]
      }
    ],
    faqs: [
      { question: 'What does a CFO do?', answer: 'CFOs provide strategic financial leadership including planning, analysis, fundraising, systems implementation, and performance management.' },
      { question: 'When should I hire a CFO?', answer: 'Consider CFO services when facing rapid growth, seeking funding, implementing new systems, or needing strategic financial guidance.' },
      { question: 'How is this different from bookkeeping?', answer: 'Bookkeeping records transactions; CFO services provide strategic analysis, planning, and leadership to drive business growth.' },
      { question: 'What is fractional CFO service?', answer: 'Fractional CFO provides part-time strategic financial leadership at a fraction of full-time executive cost.' },
      { question: 'How much time will the CFO spend?', answer: 'Engagement levels are flexible, typically ranging from 5-40 hours monthly based on business needs and complexity.' },
      { question: 'Can you help with fundraising?', answer: 'Yes, we assist with business valuations, pitch deck preparation, financial projections, and investor communications.' },
      { question: 'Do you work with startups?', answer: 'Yes, we work with businesses at all stages from startup to mature companies, scaling services to match growth.' },
      { question: 'What financial systems do you implement?', answer: 'We implement and optimize accounting software, budgeting tools, reporting systems, and financial dashboards appropriate for your business.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
